import { X } from "lucide-react";

const ViewModal = ({
  handleClose,
  role,
  handleOpenUsers,
  handleOpenRole,
  handleOpenPermissions,
  handleOpenDeleteRole,
  handleOpenRoleHistory,
}) => {
  return (
    <div
      onClick={(e) => {
        handleClose();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[1080px] h-[620px] rounded-[10px] p-[10px] relative bg-white"
      >
        <div
          onClick={handleClose}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="text-[24px] text-[#000] font-bold">{role?.name}</p>
        <div className="flex items-center gap-[20px]">
          <div className="flex items-center my-[10px] gap-[5px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M10.5558 14.8528C11.6003 14.2608 12.4195 13.3396 12.8856 12.2331C13.3517 11.1266 13.4384 9.89691 13.1323 8.73592C12.8261 7.57493 12.1443 6.54792 11.1932 5.8151C10.2421 5.08228 9.0752 4.68488 7.87453 4.68488C6.67385 4.68488 5.50693 5.08228 4.55582 5.8151C3.60471 6.54792 2.9229 7.57493 2.61675 8.73592C2.31061 9.89691 2.39734 11.1266 2.86342 12.2331C3.3295 13.3396 4.14872 14.2608 5.19328 14.8528C3.25731 15.47 1.59472 16.7384 0.487963 18.4425C0.406409 18.5675 0.377828 18.7197 0.408508 18.8657C0.439188 19.0117 0.526615 19.1396 0.651557 19.2211C0.776499 19.3027 0.928721 19.3313 1.07474 19.3006C1.22075 19.2699 1.3486 19.1825 1.43015 19.0575C2.12822 17.9842 3.08331 17.1023 4.20871 16.4917C5.33411 15.8812 6.59418 15.5614 7.87453 15.5614C9.15487 15.5614 10.4149 15.8812 11.5403 16.4917C12.6657 17.1023 13.6208 17.9842 14.3189 19.0575C14.4058 19.1689 14.5313 19.2434 14.6706 19.2665C14.81 19.2895 14.9528 19.2593 15.0709 19.1818C15.189 19.1044 15.2736 18.9853 15.308 18.8484C15.3423 18.7114 15.3239 18.5665 15.2564 18.4425C14.1508 16.7393 12.49 15.471 10.5558 14.8528ZM3.56203 10.125C3.56203 9.2721 3.81495 8.43832 4.28881 7.72913C4.76268 7.01995 5.4362 6.4672 6.2242 6.1408C7.01221 5.8144 7.87931 5.72899 8.71585 5.89539C9.5524 6.06179 10.3208 6.47252 10.9239 7.07563C11.527 7.67874 11.9378 8.44716 12.1042 9.2837C12.2706 10.1202 12.1852 10.9873 11.8588 11.7754C11.5324 12.5634 10.9796 13.2369 10.2704 13.7107C9.56124 14.1846 8.72746 14.4375 7.87453 14.4375C6.73124 14.436 5.6352 13.9812 4.82677 13.1728C4.01834 12.3644 3.56351 11.2683 3.56203 10.125ZM23.3433 19.2188C23.2184 19.3002 23.0664 19.3288 22.9205 19.2982C22.7746 19.2677 22.6468 19.1804 22.5652 19.0557C21.8683 17.9822 20.9139 17.1003 19.789 16.4902C18.664 15.88 17.4043 15.5611 16.1245 15.5625C15.9753 15.5625 15.8323 15.5033 15.7268 15.3978C15.6213 15.2923 15.562 15.1492 15.562 15C15.562 14.8508 15.6213 14.7078 15.7268 14.6023C15.8323 14.4968 15.9753 14.4375 16.1245 14.4375C16.7596 14.4369 17.3866 14.296 17.9609 14.0249C18.5352 13.7539 19.0426 13.3593 19.4467 12.8695C19.8508 12.3796 20.1418 11.8065 20.2988 11.1912C20.4558 10.5759 20.475 9.93346 20.3549 9.30986C20.2349 8.68627 19.9786 8.09687 19.6044 7.5838C19.2302 7.07072 18.7473 6.64662 18.1902 6.3418C17.6331 6.03698 17.0155 5.85896 16.3816 5.82046C15.7477 5.78196 15.1132 5.88393 14.5233 6.11909C14.4546 6.14722 14.381 6.16147 14.3067 6.16103C14.2325 6.16058 14.1591 6.14544 14.0907 6.11649C14.0224 6.08753 13.9604 6.04533 13.9085 5.99232C13.8565 5.9393 13.8155 5.87653 13.7879 5.80761C13.7603 5.73869 13.7467 5.66499 13.7477 5.59075C13.7487 5.51652 13.7644 5.44323 13.7939 5.3751C13.8234 5.30697 13.8661 5.24535 13.9195 5.19379C13.9729 5.14224 14.036 5.10177 14.1052 5.07472C15.3847 4.5646 16.8101 4.5591 18.0935 5.05934C19.3769 5.55958 20.4227 6.52827 21.0195 7.76973C21.6163 9.01119 21.7197 10.4329 21.3088 11.7476C20.8979 13.0624 20.0033 14.1722 18.8058 14.8528C20.7417 15.47 22.4043 16.7384 23.5111 18.4425C23.5915 18.5678 23.619 18.7198 23.5876 18.8653C23.5561 19.0108 23.4683 19.1379 23.3433 19.2188Z"
                fill="#19C1E4"
              />
            </svg>
            <p className="cursor-pointer" onClick={handleOpenUsers}>
              Manage Users{" "}
              <span className="text-[#19C1E4] text-[14px]">
                ({role?.users?.length})
              </span>
            </p>
          </div>
          <div className="flex items-center my-[10px] gap-[5px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <g clip-path="url(#clip0_6668_3721)">
                <path
                  d="M10.596 0C13.822 0 16.438 2.566 16.438 5.732C16.4372 6.56421 16.2534 7.38607 15.8997 8.13935C15.546 8.89264 15.0309 9.55892 14.391 10.091C14.665 10.224 14.914 10.358 15.139 10.493C15.624 10.783 16.127 11.143 16.649 11.572C16.7194 11.6291 16.7777 11.6998 16.8204 11.7798C16.8631 11.8598 16.8893 11.9476 16.8975 12.0379C16.9057 12.1283 16.8957 12.2193 16.8681 12.3057C16.8406 12.3921 16.796 12.4721 16.737 12.541C16.6161 12.6814 16.4451 12.769 16.2605 12.7851C16.0759 12.8012 15.8923 12.7444 15.749 12.627C15.3265 12.2745 14.8786 11.9536 14.409 11.667C13.9509 11.4005 13.4751 11.1656 12.985 10.964C12.2318 11.2952 11.4178 11.4655 10.595 11.464C9.68846 11.4656 8.79372 11.2586 7.97999 10.859L7.93799 10.879C5.96099 11.635 4.51799 12.753 3.58799 14.237C2.65299 15.726 2.27099 17.39 2.44199 19.251C2.44938 19.3418 2.43877 19.4331 2.41077 19.5198C2.38278 19.6064 2.33796 19.6867 2.27887 19.756C2.21978 19.8253 2.1476 19.8823 2.06645 19.9237C1.9853 19.965 1.89679 19.9899 1.80599 19.997C1.62255 20.0149 1.43949 19.9594 1.29688 19.8426C1.15426 19.7259 1.06369 19.5574 1.04499 19.374C0.847994 17.222 1.29799 15.261 2.39299 13.516C3.35699 11.98 4.77299 10.786 6.62299 9.935C6.03463 9.40421 5.56419 8.75588 5.24208 8.0319C4.91997 7.30792 4.75335 6.5244 4.75299 5.732C4.75299 2.566 7.36999 0 10.596 0ZM17.819 14.24C17.9491 14.1115 18.1245 14.0391 18.3074 14.0386C18.4903 14.038 18.6661 14.1093 18.797 14.237C19.067 14.503 19.067 14.935 18.799 15.202L17.607 16.381L18.799 17.561C18.863 17.624 18.9137 17.6991 18.9483 17.7819C18.9829 17.8647 19.0006 17.9537 19.0004 18.0434C19.0003 18.1332 18.9822 18.222 18.9472 18.3047C18.9123 18.3874 18.8612 18.4623 18.797 18.525C18.6664 18.653 18.4907 18.7246 18.3078 18.7244C18.1249 18.7242 17.9494 18.6523 17.819 18.524L16.632 17.347L15.445 18.524C15.3285 18.6385 15.1755 18.7085 15.0127 18.7219C14.8499 18.7352 14.6876 18.691 14.554 18.597L14.468 18.525C14.4038 18.4623 14.3527 18.3874 14.3178 18.3047C14.2828 18.222 14.2647 18.1332 14.2645 18.0434C14.2644 17.9537 14.2821 17.8647 14.3167 17.7819C14.3513 17.6991 14.402 17.624 14.466 17.561L15.656 16.381L14.466 15.201C14.402 15.138 14.3513 15.0629 14.3167 14.9801C14.2821 14.8973 14.2644 14.8083 14.2645 14.7186C14.2647 14.6288 14.2828 14.54 14.3178 14.4573C14.3527 14.3746 14.4038 14.2997 14.468 14.237C14.5987 14.1094 14.7742 14.0382 14.9569 14.0386C15.1396 14.0389 15.3148 14.1109 15.445 14.239L16.632 15.415L17.819 14.24ZM10.596 1.375C8.14299 1.375 6.15599 3.325 6.15599 5.731C6.15599 8.137 8.14299 10.088 10.596 10.088C13.048 10.088 15.036 8.138 15.036 5.731C15.036 3.325 13.048 1.375 10.596 1.375Z"
                  fill="#19C1E4"
                />
              </g>
              <defs>
                <clipPath id="clip0_6668_3721">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p className="cursor-pointer" onClick={handleOpenDeleteRole}>
              Delete Role
            </p>
          </div>
        </div>
        <div className="border-b-[4px] mb-[10px] w-[120px] border-[#456F94]">
          <p className="text-[#000] font-bold text-[18px]">Role Details</p>
        </div>
        <div className="w-[100%] flex">
          <div className="w-[100%]">
            <div className="w-[100%]">
              <div className="w-full flex mb-[10px] gap-[15px]">
                <div className="w-[48%] pr-[20px]">
                  <p className="text-[#000] font-bold text-[15px]">
                    Role Name and Description
                  </p>
                  <p>{role?.name}</p>
                  <p>{role?.description}</p>
                  <p
                    onClick={handleOpenRole}
                    className="mt-[10px] text-[#19C1E4] cursor-pointer"
                  >
                    Manage role name and description
                  </p>
                </div>
                <div className="w-[48%%]">
                  <p className="text-[#000] font-bold text-[15px]">
                    Audit Role
                  </p>
                  <p>view history of actions performed on the role</p>
                  <p
                    onClick={handleOpenRoleHistory}
                    className="mt-[10px] text-[#19C1E4] cursor-pointer"
                  >
                    View history
                  </p>
                </div>
              </div>
              <p className="text-[#000] font-bold text-[15px]">Permissions</p>
              <div className="w-full h-[180px] overflow-y-auto">
                {role?.permissions?.map((permission) => (
                  <p>{permission?.name}: read only</p>
                ))}
              </div>
              <p
                onClick={handleOpenPermissions}
                className="text-[#19C1E4] mt-[10px] cursor-pointer"
              >
                Manage permissions
              </p>
            </div>
          </div>
        </div>
        <div className=" mt-[10px] flex w-full justify-end">
          <button
            onClick={handleClose}
            className="bg-[#D9D9D9] h-[45px] px-[20px] hover:bg-[#FF3232] hover:text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewModal;
